import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {faInfoCircle, faSyncAlt} from "@fortawesome/pro-solid-svg-icons";
import {Audit, AuditService} from "@webmate-web-core/shared/services/audit.service";
import {audit as auditIcon} from "@webmate-web-core/shared/icons";
import {take} from 'rxjs/operators';

@Component({
    selector: 'wm-audit-ref',
    templateUrl: './audit-ref.component.html',
    styleUrls: ['./audit-ref.component.less']
})
export class AuditRefComponent implements OnChanges {
    constructor(private auditService: AuditService) {}

    @Input()
    auditId: string;

    audit?: Audit;

    isError = false;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.auditId) {
            this.loadAudit();
        }
    }

    private loadAudit() {
        this.audit = undefined;
        this.isError = false;
        if (!this.auditId) {
            return;
        }
        this.auditService.getAudit$(this.auditId).pipe(take(1)).subscribe({
            next: (audit) => {
                this.audit = audit;
            },
            error: (error) => {
                this.isError = true;
            }
        });
    }

    protected readonly faSyncAlt = faSyncAlt;
    protected readonly faInfoCircle = faInfoCircle;
    protected readonly auditIcon = auditIcon;
}
